import { Tag } from 'antd';
import { SwapOutlined, DatabaseOutlined } from '@ant-design/icons';
import type { IWhTaskTypeTagProps } from './types';
import styles from './wh-task-type-tag.module.scss';

export const WhTaskTypeTag = (props: IWhTaskTypeTagProps) => {
  const { type } = props;
  const TypeIcon = type === 'reloading' ? SwapOutlined : DatabaseOutlined;

  return (
    <Tag>
      <TypeIcon className={styles.tagIcon} />
      {type}
    </Tag>
  );
};
